<template>
  <div class="actions-publish">
    <div style="text-align: left; padding-bottom: 0px">
      <div style="text-transform: uppercase; color: #666; font-size: 1.1em"
        >Reports to Publish</div
      >
      <div
        style="
          margin-top: 7px;
          padding-top: 7px;
          border-top: 1px solid whiteSmoke;
        "
        :key="report.id"
        v-for="report in localReports"
      >
        <label>
          <input
            type="checkbox"
            v-model="report.selected"
            style="
              position: relative;
              left: auto;
              opacity: 100%;
              margin-top: 0px;
              margin-right: 5px;
            "
          />
          <span style="font-size: 1.2em">{{ report.name }}</span>
          <span
            v-if="report.published && report.viewed"
            class="fg-success fa fa-check-square-o"
          />
          <v-tooltip
            v-else-if="report.published"
            top
            content-class="info-tooltip"
          >
            <span slot="activator" class="fg-success fa fa-paper-plane-o" />
            This report has been published
          </v-tooltip>
        </label>
      </div>
      <hr />
    </div>
    <div class="actions-publish actions-inner">
      <div v-if="autoLoaded !== 3">
        <div class="loading">
          <h1 class="px-0 center">Loading Actions</h1>
        </div>
      </div>
      <p class="explainer-text">
        Select the actions you want to trigger when publishing your
        {{ publishObject }}.
        <br />
        If you don't want one of your actions to trigger make sure to turn it
        off!
      </p>
      <div v-if="autoLoaded === 3 && inspectionRuns.length > 0">
        <div class="expandable-section" v-if="todaysRuns.length > 0">
          <div
            class="expandable-header"
            :class="{ open: showToday }"
            @click="showToday = !showToday"
          >
            <div class="publish-category-header">
              <i
                class="fa fa-chevron-right light"
                :class="{ rotate90: showToday }"
              />
              Actions going out in next 24hrs
            </div>

            <div class="track-count">
              <template v-if="todaysRuns.length === 1"> 1 Action </template>
              <template v-else-if="todaysRuns.length > 1">
                {{ todaysRuns.length }} Actions
              </template>
            </div>
          </div>
          <div v-if="showToday" class="run-container">
            <div v-for="run in todaysRuns" :key="run.id">
              <auto-track-run
                :actions="actions"
                :conditions="conditions"
                :events="events"
                :trackRun="run"
                :companyId="inspection.company_id"
                @updatedRecord="updatedRecord"
                @addDuplicate="addDuplicate"
              />
            </div>
          </div>
        </div>

        <div class="expandable-section" v-if="laterRuns.length > 0">
          <div
            class="expandable-header"
            :class="{ open: showLater }"
            @click="showLater = !showLater"
          >
            <div class="publish-category-header">
              <i
                class="fa fa-chevron-right light"
                :class="{ rotate90: showLater }"
              />
              Actions going out in the future
            </div>
            <div class="track-count">
              <template v-if="laterRuns.length === 1"> 1 Action </template>
              <template v-else-if="laterRuns.length > 1">
                {{ laterRuns.length }} Actions
              </template>
            </div>
          </div>
          <div v-if="showLater" class="run-container">
            <div v-for="run in laterRuns" :key="run.id">
              <auto-track-run
                :actions="actions"
                :conditions="conditions"
                :events="events"
                :trackRun="run"
                :companyId="inspection.company_id"
                @updatedRecord="updatedRecord"
                @addDuplicate="addDuplicate"
              />
            </div>
          </div>
        </div>
      </div>

      <div v-else>
        <p>You have no Actions setup to trigger when Reports are published.</p>
      </div>
      <div class="section">
        <div class="section center">
          <div class="btn btn-xlarge" @click="save">
            <div v-if="!saving" class="fa fa-paper-plane-o" />
            <div v-else class="fa fa-spinner fa-spin" />
            Save & Publish
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '../../AxiosService'
import dig from '../../Dig'
import AutoTrackRun from './actions_publish/AutoTrackRun'

export default {
  components: {
    AutoTrackRun,
  },
  computed: {
    autoEvents() {
      return ['reports_published']
    },
    dataElement() {
      return document.getElementById('actions-publish-data')
    },
    hasReportsSelected() {
      return this.localReports.filter((r) => r.selected).length > 0
    },
    laterRuns() {
      return this.inspectionRuns.filter((ir) => {
        let o = ir.offset

        return o > 0 && ((o > 3600 && o !== 86400) || o > 3600 * 24)
      })
    },
    publishObject() {
      return this.reportId ? 'Report' : 'Inspection'
    },
    publishUrl() {
      if (this.reportId) {
        return `/reports/${this.reportId}/publish`
      } else {
        return `/inspections/${this.inspection.id}/publish`
      }
    },
    todaysRuns() {
      let laterRunIds = this.laterRuns.map((r) => {
        return r.id
      })

      return this.inspectionRuns.filter((ir) => {
        return !laterRunIds.includes(ir.id)
      })
    },
  },
  data() {
    return {
      actions: [],
      autoLoaded: 0,
      charges: [],
      conditions: [],
      events: [],
      filtered: false,
      inspection: {},
      inspectionRuns: [],
      inspectors: [],
      reportId: null,
      saving: false,
      showLater: false,
      showToday: true,
    }
  },
  created() {
    this.fillData()
    this.fetchAutoData()
  },
  methods: {
    addDuplicate(dup) {
      delete dup.id
      this.updatedRecord(dup)
    },
    conditionHasRecipient(run) {
      let recipients = dig(run, 'params.to', []).reduce((summ, r) => {
        let lower = r.toLowerCase()

        if (['buyers', 'clients'].includes(lower)) {
          if (this.inspection.buyer_id) summ.push(r)
        } else if (lower === 'inspectors') {
          if (this.inspectors.length > 0) summ.push(r)
        } else if (['buying_agent', 'client agent'].includes(lower)) {
          if (this.inspection.buying_agent_id) summ.push(r)
        } else if (['selling_agent', 'selling agent'].includes(lower)) {
          if (this.inspection.selling_agent_id) summ.push(r)
        } else {
          summ.push(r)
        }
        return summ
      }, [])

      return recipients.length > 0
    },
    conditionsMet(run) {
      let display = true
      if (display) display = this.conditionHasRecipient(run)

      return display
    },
    close() {
      this.filtered = false
      this.$emit('closed')
    },
    updateRuns() {
      return this.inspectionRuns.map((at) => {
        if (at.grantedId) {
          return axios.post('/api/v1/auto_track_runs', this.runParams(at))
        } else if (at.updated) {
          return axios.put(
            `/api/v1/auto_track_runs/${at.id}`,
            this.runParams(at)
          )
        }
      })
    },
    fetchAutoData() {
      axios
        .get(`/api/v1/auto_actions?company_id=${this.inspection.company_id}`)
        .then((response) => {
          this.actions = response.data.data
          this.autoLoaded += 1
        })
      axios
        .get(`/api/v1/auto_conditions?company_id=${this.inspection.company_id}`)
        .then((response) => {
          this.conditions = response.data.data
          this.autoLoaded += 1
        })
      axios.get('/api/v1/auto_events').then((response) => {
        this.events = response.data.data
        this.autoLoaded += 1
      })
    },
    fetchRuns() {
      axios
        .get(
          `/api/v1/auto_track_runs?inspection_id=${this.inspection.id}&view=meets_conditions&auto_event=reports_published`
        )
        .then((response) => {
          let runs = response.data.data.filter((r) => {
            return (
              r.attributes.auto_action !== 'disabled' &&
              r.attributes.meets_conditions &&
              !r.attributes.parent_run_id
            )
          })

          runs = runs.map((r) => {
            return r.attributes
          })
          this.inspectionRuns = runs
        })
    },
    fillData() {
      this.inspection = JSON.parse(
        this.dataElement.attributes['data-inspection'].value
      )
      this.reportId = (
        this.dataElement.attributes['data-report-id'] || {}
      ).value
      this.inspectors = JSON.parse(
        this.dataElement.attributes['data-inspectors'].value
      )
      this.charges = JSON.parse(
        this.dataElement.attributes['data-charges'].value
      )
      this.reports = JSON.parse(
        this.dataElement.attributes['data-reports'].value
      )
      this.reportAttachmentCount = JSON.parse(
        this.dataElement.attributes['data-reports-attachment-count'].value
      )

      this.localReports = this.reports.map((report) => {
        report.selected = true
        return { ...report }
      })
      this.fetchRuns()
    },
    forceSave() {
      this.save(null, true)
    },
    publish() {
      const params = {
        report_ids: this.localReports
          .filter((report) => report.selected)
          .map((report) => report.id),
      }

      if (this.localReports.length !== 0 && params.report_ids.length === 0) {
        alert('You must select at least one report to publish.')
        this.saving = false
        return
      }

      axios
        .post(
          `${this.publishUrl}?publish_to_client_email=false&publish_to_agent_email=false&publish_to_client_sms=false&publish_to_agent_sms=false`,
          params
        )
        .then(() => {
          window.location.reload()
        })
    },
    save() {
      if (!this.saving) {
        this.saving = true
        return Promise.all(this.updateRuns())
          .then((response) => {
            this.publish()
          })
          .catch((error) => {
            console.log(error)
            this.saving = false
          })
      }
    },
    runParams(autoTrack) {
      let run = {}

      run.inspection_id = this.inspection.id
      run.auto_track_id = autoTrack.auto_track_id
      run.auto_event = autoTrack.auto_event
      run.conditions = autoTrack.conditions
      run.auto_action = autoTrack.auto_action
      run.is_locked = autoTrack.is_locked
      run.params = autoTrack.params
      run.offset = autoTrack.offset
      run.offset_multiplier = autoTrack.offset_multiplier
      run.scheduling_options = autoTrack.scheduling_options

      if (autoTrack.is_failed || autoTrack.is_fullfilled)
        run.runtime = new Date()

      return { attributes: run }
    },
    tempRecordId(record) {
      return [
        record.auto_event,
        record.auto_action,
        record.auto_track_group_id,
        record.params.to[0],
      ].join('-')
    },
    updatedRecord(record) {
      if (!record.id) {
        record.id = this.tempRecordId(record)
        record.grantedId = true
        this.inspectionRuns = this.inspectionRuns.concat([record])
      } else {
        record.updated = true
        if (
          this.inspectionRuns.find((ur) => {
            return ur.id === record.id
          })
        ) {
          this.inspectionRuns.forEach((ir) => {
            if (ir.id === record.id) {
              ;[
                'updated',
                'grantedId',
                'is_locked',
                'offset',
                'scheduling_options',
                'conditions',
                'params',
                'offset_multiplier',
                'auto_action',
              ].forEach((att) => {
                ir[att] = record[att]
              })
            }
          })
        } else {
          this.inspectionRuns = this.inspectionRuns.concat([record])
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.explainer-text {
  font-size: 1.25em;
}

.expandable-header {
  color: #888;
  padding: 0.5em;
  margin-top: 1em;
  cursor: pointer;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .fa {
    font-size: 0.75em;
    transition: 0.1s;
  }
  span {
    margin-left: 0.5em;
  }

  &.open {
    border-bottom: 1px solid #ddd;
  }
}

.track-count {
  height: 32px;
  border-radius: 28px;
  cursor: default;
  padding: 0 12px;
  white-space: nowrap;
  background-color: #fff;
  border: 1px solid #888;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75em;
}

.publish-category-header {
  cursor: pointer;
  font-size: 1.25em;
  font-weight: 300;
  display: inline-block;
}

.expandable-section {
  background-color: #fff;
  box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14),
    0 1px 3px 0 rgba(0, 0, 0, 0.12);
}

.run-container {
  background-color: #fff;
  padding: 0.5em;
}

.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.3s ease;
}
.slide-down-enter-active {
  transition-delay: 0.5s;
}
.slide-down-enter-active.no-delay {
  transition-delay: 0s;
}
.slide-down-enter,
.slide-down-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}
</style>
